var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backstage-index"},[_c('page-head',{on:{"loginOut":_vm.loginOut}}),_c('PageTags'),_c('div',{staticClass:"backstage-container",attrs:{"id":"pageContent"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }